import { messageReducer } from './messageReducer';
import { authReducer } from './authReducer';
import { sessionReducer } from './sessionReducer';

export const reducers = { 
  messageState: messageReducer, 
  authState: authReducer, 
  sessionState: sessionReducer,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/index.ts